'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPricetags = function IoIosPricetags(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.8 5h1.2v11.3l-18.7 21.2-1.1-1 18.6-20.8v-10.7z m-13.8-2.5h12.5v12.5l-17.3 19.8-0.9 0.8-1.8 1.9-12.5-12.5z m5 10c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-1.2-2.5c0-0.9 0.3-1.2 1.2-1.2s1.3 0.3 1.3 1.2-0.4 1.3-1.3 1.3-1.2-0.4-1.2-1.3z' })
        )
    );
};

exports.default = IoIosPricetags;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-pricetags.js
// module id = 2490
// module chunks = 0